import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  
  const currentLang = i18n.language?.split('-')[0] || 'de';

  const changeLanguage = (langCode: string) => {
    i18n.changeLanguage(langCode);
  };

  return (
    <div className="flex items-center text-xs sm:text-sm font-medium shrink-0">
      <button
        onClick={() => changeLanguage('de')}
        className={cn(
          "px-1 sm:px-1.5 py-0.5 sm:py-1 transition-colors",
          currentLang === 'de' 
            ? "text-foreground" 
            : "text-muted-foreground hover:text-foreground"
        )}
        aria-label="Deutsch"
        aria-current={currentLang === 'de' ? 'true' : undefined}
      >
        DE
      </button>
      <span className="text-muted-foreground">/</span>
      <button
        onClick={() => changeLanguage('en')}
        className={cn(
          "px-1 sm:px-1.5 py-0.5 sm:py-1 transition-colors",
          currentLang === 'en' 
            ? "text-foreground" 
            : "text-muted-foreground hover:text-foreground"
        )}
        aria-label="English"
        aria-current={currentLang === 'en' ? 'true' : undefined}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
